import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 306036 323063"
    {...props}
  >
    <path
      d="M151925 0c32454 0 60247 6552 83460 19721 23208 13094 40815 31793 52750 56023 11934 24230 17901 52683 17901 85351 0 24158-3273 46131-9825 65848-6547 19792-16296 36891-29394 51371-13098 14481-29104 25537-48170 33252-19060 7640-40820 11497-65410 11497-24449 0-46351-3929-65630-11863-19355-7858-35437-18989-48388-33323-12951-14333-22700-31579-29323-51804C3273 205915 0 184089 0 160658c0-24012 3421-45985 10333-66067 6913-20011 16880-37033 29979-51148 13022-14044 28957-24815 47728-32236C106739 3710 128061 0 151925 0zm89935 160658c0-22848-3710-42711-11060-59520-7421-16733-17972-29394-31650-38050-13683-8590-29470-12880-47225-12880-12585 0-24301 2399-34995 7131-10770 4803-20011 11711-27726 20809-7711 9093-13821 20738-18334 34853-4438 14186-6694 30050-6694 47657 0 17825 2256 33836 6694 48241 4513 14333 10841 26267 18989 35727 8153 9459 17536 16514 28088 21174 10623 4728 22191 7056 34853 7056 16224 0 31071-4072 44673-12149 13535-8076 24305-20595 32382-37546 8000-16880 12005-37765 12005-62503z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
